module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_up.05742.png";